export default (() => {
  if (!customElements.get('product-detail-label')) {
    customElements.define('product-detail-label', class ProductDetailLabel extends HTMLElement {
      constructor() {
        super();
        this.label = this.querySelector('label');
        this.modal = null;
        this.handleClick = this.handleClick.bind(this);
      }

      /**
       * Helper to safely extract Variant ID from the page
       */
      getItemId() {
        try {
          // Attempt 1: Look for a hidden input inside the product section's product form
          const productSection = this.closest('[data-product]') || this.closest('.shopify-section');
          let idInput = productSection.querySelector('form[action*="/cart/add"] [name="id"]');
          if (idInput) return idInput.dataset.variantSku || idInput.value;

          // Attempt 2: Look for a hidden input inside the document product form
          idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
          if (idInput) return idInput.dataset.variantSku || idInput.value;

          // Attempt 3: Look for the main product form
          const productForm = document.querySelector('product-form[data-product-id]');
          if (productForm) return productForm.getAttribute('data-product-id');
          return ''; // Return empty string if not found to avoid null errors
        } catch (e) {
          return '';
        }
      }

      /**
       * Helper to safely extract Product ID from the page
       */
      getProductId() {
        try {
          const productForm = document.querySelector('product-form[data-product-id]');
          if (productForm) return productForm.getAttribute('data-product-id');
          return ''; // Return empty string if not found to avoid null errors
        } catch (e) {
          return '';
        }
      }

      /**
       * Helper to safely extract Product Title from the page
       */
      getProductTitle() {
        try {
          const productForm = document.querySelector('product-scroll[data-product-title]');
          if (productForm) return productForm.getAttribute('data-product-title');
          return ''; // Return empty string if not found to avoid null errors
        } catch (e) {
          return '';
        }
      }
      handleClick(event) {
        const key = this.label.getAttribute('data-key');
        const input = document.getElementById(`${key}`);
        if (input) input.click();
        try {
          // Only run on PDPs (based on schema requirement)
          const template = document.body.getAttribute('data-template');
          if (template === 'product') {
            const questionText = this.label ? this.label.textContent.trim() : null;
            const itemId = this.getItemId();
            const productId = this.getProductId();
            const productTitle = this.getProductTitle();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'select_content',
              content_type: 'pdp_information',
              item_id: itemId,
              item_name: productTitle,
              product_id: productId,
              faq_question: questionText,
              page_section: 'main-content',
              page_type: 'pdp'
            });
          }
        } catch (err) {
          console.warn('GTM Error in product-detail-label:', err);
        }
      }
      connectedCallback() {
        if (!this.label) return;
        this.label.addEventListener('click', this.handleClick);
        const labelFor = this.label.getAttribute('for');
        this.modalEl = document.getElementById(labelFor);
        const urlParams = new URLSearchParams(window.location.search);
        const labelKey = urlParams.get('product-detail-label-key');
        if (labelKey) {
          urlParams.delete('product-detail-label-key');
          const newUrl = urlParams.toString() ? `${window.location.pathname}?${urlParams.toString()}` : window.location.pathname;
          window.history.replaceState({}, '', newUrl);
          if (this.modalEl) this.modalEl.click();
          const targetElement = document.getElementById(labelKey);
          if (targetElement) {
            targetElement.click();
          }
        }
      }
      disconnectedCallback() {
        if (this.label) {
          this.label.removeEventListener('click', this.handleClick);
        }
      }
    });
  }
})();